import { escapeUserText } from "../../utils/mentions";
// GroupPostsPublicView.js
import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import GroupPostForm from './GroupPostForm';
import GroupPostCard from './GroupPostcard';
import LikeButtons from '../icon/LikeButton';
import UnLikeButtons from '../icon/unlikebutton';
import Slider from 'react-slick';
import { AnimatePresence, color, motion } from 'framer-motion';


import { FaChevronLeft, FaChevronRight } from 'react-icons/fa';
import Modal from 'react-modal';

import { getAuthorDisplayName } from '../../utils/displayName';
import { getApiBaseUrl } from '../../config/api';
import { nestGroupReplies } from '../../utils/nestReplies';
import { resolveAvatarUrl, handleAvatarError } from '../../utils/profilePicUrl';
import { isMediaImage, isMediaVideo, isDisplayableMedia, getMediaMimeType } from '../../utils/mediaDetect';
import PostMediaGrid from '../shared/PostMediaGrid';
import GroupReplyItem from './GroupReplyItem';

const GroupPosts = ({ user }) => {
  const { groupId } = useParams();
  const [posts, setPosts] = useState([]);
  const [likes, setLikes] = useState({});
  const [userLiked, setUserLiked] = useState({});
  const [repliesByPostId, setRepliesByPostId] = useState({});
  const [showReplies, setShowReplies] = useState({});
  const [expandedContent, setExpandedContent, setActiveReplyBox] = useState({});
  const [setExpandedPostId, setPopupImage, setShowDropdown, showDropdown] = useState(null);
  const [showAllImages,expandedPostId, setShowAllImages,toggleReplyForm] = useState({}); // key by reply.id
 
  const API_URL = getApiBaseUrl();

  const openImagePopup = (url) => setPopupImage(url);
  const closePopup = () => setPopupImage(null);

  const toggleReplies = (postId) => {
    setShowReplies((prev) => ({
      ...prev,
      [postId]: !prev[postId],
    }));
  };
  const [popupPhoto, setPopupPhoto] = useState(null); // ✅ add this state

  const isImage = (url, type) => isMediaImage(url, type);
const isVideo = (url, type) => isMediaVideo(url, type);
const isAudio = (url) => /\.(mp3|wav|ogg)$/i.test(url);
const isDocument = (url) => /\.(pdf|docx?|pptx?|xlsx?)$/i.test(url);

const getMimeType = (url, type) => getMediaMimeType(url, type);


const formatDate = (timestamp) => {
  const targetTimeZone = "Asia/Manila";
  const date = new Date(timestamp); // let JS parse it

  const now = new Date();
  const diffSeconds = Math.floor((now - date) / 1000);

  if (diffSeconds < 60) return "just now";
  if (diffSeconds < 3600) {
    const minutes = Math.floor(diffSeconds / 60);
    return `${minutes} minute${minutes > 1 ? "s" : ""} ago`;
  }
  if (diffSeconds < 86400) {
    const hours = Math.floor(diffSeconds / 3600);
    return `${hours} hour${hours > 1 ? "s" : ""} ago`;
  }

  return new Intl.DateTimeFormat("en-US", {
    year: "numeric",
    month: "short",
    day: "numeric",
    hour: "numeric",
    minute: "2-digit",
    hour12: true,
    timeZone: targetTimeZone
  }).format(date);
};


  const fetchPosts = async () => {
    try {
      const res = await fetch(`${API_URL}/get_group_posts.php?group_id=${groupId}`);
      const data = await res.json();
      if (data.success) {
        const postsWithThreads = (data.posts || []).map((p) => {
          const flat = p.replies || [];
          return {
            ...p,
            replyCount: flat.length,
            replies: nestGroupReplies(flat),
          };
        });
        setPosts(postsWithThreads);

        const likeCounts = {};
        const likedStatus = {};
        const repliesMap = {};

        postsWithThreads.forEach((post) => {
          likeCounts[`post_${post.id}`] = post.like_count || 0;
          likedStatus[`post_${post.id}`] = false; // public view

          const replies = post.replies || [];
          repliesMap[post.id] = replies;

          replies.forEach((reply) => {
            likeCounts[`reply_${reply.id}`] = reply.like_count || 0;
            likedStatus[`reply_${reply.id}`] = false; // public view
          });
        });

        setLikes(likeCounts);
        setUserLiked(likedStatus);
        setRepliesByPostId(repliesMap);
      }
    } catch (err) {
      console.error('Error fetching posts:', err);
    }
  };

  useEffect(() => {
    if (groupId) fetchPosts();
  }, [groupId]);

  const formatTimeAgo = (dateString) => {
    const diff = Date.now() - new Date(dateString).getTime();
    const seconds = Math.floor(diff / 1000);
    const minutes = Math.floor(seconds / 60);
    const hours = Math.floor(minutes / 60);
    const days = Math.floor(hours / 24);

    if (days > 0) return `${days}d ago`;
    if (hours > 0) return `${hours}h ago`;
    if (minutes > 0) return `${minutes}m ago`;
    return 'Just now';
  };

  const handleLike = async (id, groupId, type = 'post') => {
    if (!user) return; // public view cannot like
    const key = `${type}_${id}`;
    const liked = userLiked[key];
    const url = liked ? 'unlike_group_post.php' : 'like_group_post.php';

    try {
      const res = await fetch(`${API_URL}/${url}`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: new URLSearchParams({
          user_id: user.id,
          target_id: id,
          group_id: groupId,
          target_type: type
        })
      });
      const data = await res.json();
      if (data.success) {
        setLikes(prev => ({
          ...prev,
          [key]: liked ? Math.max(0, (prev[key] || 1) - 1) : (prev[key] || 0) + 1
        }));
        setUserLiked(prev => ({
          ...prev,
          [key]: !liked
        }));
      }
    } catch (err) {
      console.error('Like/unlike request failed:', err.message);
    }
  };

  const Arrow = ({ onClick, direction }) => (
    <div
      onClick={onClick}
      style={{
        position: 'absolute',
        top: '50%',
        [direction]: 10,
        transform: 'translateY(-50%)',
        zIndex: 2,
        backgroundColor: '#fff',
        borderRadius: '50%',
        padding: 8,
        boxShadow: '0 0 8px rgba(0,0,0,0.1)',
        cursor: 'pointer',
      }}
    >
      {direction === 'left' ? <FaChevronLeft size={20} /> : <FaChevronRight size={20} />}
    </div>
  );

  const sliderSettings = {
    dots: true,
    infinite: false,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    prevArrow: <Arrow direction="left" />,
    nextArrow: <Arrow direction="right" />,
  };

  const createLinkifiedText = (text) => {
  return escapeUserText(text || '')
    .replace(
      /@\[([^\]]+)\]\(user:(\d+)\)/g,
      '<a href="/profile/$2" style="color:#2563eb;font-weight:600;text-decoration:none;">@$1</a>'
    )
    .replace(
      /(https?:\/\/[^\s]+)/g,
      '<a href="$1" target="_blank" rel="noopener noreferrer" style="color:#2563eb">$1</a>'
    );
};

  const replyCtx = {
    API_URL,
    user,
    userLiked,
    likes,
    expandedContent,
    setExpandedContent,
    showAllImages,
    setShowAllImages,
    activeReplyBox: {},
    setActiveReplyBox: () => {},
    nestedReplyText: {},
    setNestedReplyText: () => {},
    nestedReplyMedia: {},
    setNestedReplyMedia: () => {},
    handleLike,
    handleDeleteReply: async () => {},
    handleNestedReplySubmit: async () => {},
    formatDate,
    createLinkifiedText,
  };

  return (
<div className="post-list" style={{ maxWidth: '800px', margin: 'auto', padding: '20px 10px 100px 5px' }}>

 
      {posts.length === 0 ? (
        <p>No posts yet.</p>
      ) : (
        posts.map((post) => (
         <div
        key={post.id}
        className="post-card"
      style={{
borderRadius: window.innerWidth <= 768 ? '0' : '16px',
padding: '20px',
marginBottom: '10px',
backgroundColor: '#ffffff',
boxShadow: '20px 20px 20px rgba(5, 4, 4, 0.05)',
borderTop: '1px solid #eaeaea',
borderBottom: '1px solid #eaeaea',
borderLeft: window.innerWidth <= 768 ? 'none' : '1px solid #eaeaea',
borderRight: window.innerWidth <= 768 ? 'none' : '1px solid #eaeaea',
transition: 'all 0.3s ease',
width: window.innerWidth <= 768 ? '100vw' : 'auto', // ✅ full edge width
marginLeft: window.innerWidth <= 768 ? '50%' : 'auto', // ✅ center alignment
transform: window.innerWidth <= 768 ? 'translateX(-50%)' : 'none', // ✅ prevents overflow
marginRight: 'auto',
}}


      >

      <div style={{ position: 'relative' }}>
      
      
     {user && (Number(user.id) === Number(post.user_id) || user.role === "admin") && (
        <div style={{ position: 'absolute', top: '10px', right: '10px', zIndex: 1000 }}>
          <div style={{ position: 'relative', display: 'inline-block' }}>
            <button
              onClick={() => setShowDropdown((prev) => ({ ...prev, [post.id]: !prev[post.id] }))}
              style={{
                background: 'none',
                border: 'none',
                fontSize: '20px',
                cursor: 'pointer',
                color: '#555',
                padding: '6px',
              }}
            >
              ⋮
            </button>
      
            {showDropdown?.[post.id] && (
              <div
                style={{
                  position: 'absolute',
                  right: 0,
                  top: '30px',
                  backgroundColor: 'white',
                  border: '1px solid #ccc',
                  borderRadius: '6px',
                  boxShadow: '0 2px 6px rgba(0,0,0,0.15)',
                  minWidth: '120px',
                  zIndex: 1001,
                }}
              >
      
               
            
                
                
                
              </div>
            )}
          </div>
        </div>
      )}
      
            {/* Header */}
            <div>
       <h2 style={{
        fontSize: '20px',
        fontWeight: '700',
        color: '#102a43',
        marginBottom: '16px'
      }}>
  
              {post.title}

              
     
      </h2>
              <div style={{ fontSize: 12, color: '#666' }}>
            <div style={{ display: 'flex', alignItems: 'center', marginBottom: '12px' }}>
                  <img
  src={resolveAvatarUrl(post, API_URL)}
  alt="avatar"
  style={{
    width: '48px',
    height: '48px',
    borderRadius: '50%',
    objectFit: 'cover',
    marginRight: '12px',
  }}
  onError={handleAvatarError}
/>
                   <div>
                     <div style={{ fontWeight: 600 }}>{getAuthorDisplayName(post)}</div>
                     <div style={{ fontSize: '12px', color: '#6b7280' }}>
                       {formatDate(post.created_at)} · {post.category}{post.position ? ` · ${post.position}` : ''} · {post.country}
                     </div>
                   </div>
                 </div>
            </div>

        {/* 🔹Content */}
          <p
          style={{
            fontSize: "15px",
            color: "#374151",
            marginBottom: "8px",
            whiteSpace: "pre-wrap",
               wordBreak: "break-word",
    overflowWrap: "anywhere",
          }}
          dangerouslySetInnerHTML={{
            __html:
              expandedContent[post.id] || post.content.split(" ").length <= 50
                ? createLinkifiedText(String(post.content))
                : createLinkifiedText(
                    String(post.content).split(" ").slice(0, 50).join(" ") + "..."
                  ),
          }}
          
        ></p>
      
      {post.content.split(' ').length > 50 && (
        <button
          onClick={() =>
            setExpandedContent((prev) => ({
              ...prev,
              [post.id]: expandedContent[post.id] ? null : post.content
            }))
          }
          style={{
            background: 'none',
            border: 'none',
            color: '#2563eb',
            cursor: 'pointer',
            fontSize: '14px',
            padding: 0
          }}
        >
          {expandedContent[post.id] ? 'See less' : 'See more'}
        </button>
      )}
  <>
<div>
      {Array.isArray(post.media) && post.media.length > 0 && (
        <PostMediaGrid
          media={post.media}
          onImageClick={setPopupPhoto}
        />
      )}

      {/* Popup */}
      {popupPhoto && (
        <div
          onClick={closePopup}
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100vw',
            height: '100vh',
            backgroundColor: 'rgba(0,0,0,0.8)',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            zIndex: 1000,
            cursor: 'pointer',
          }}
        >
          <img
            src={popupPhoto}
            alt="popup"
            style={{
              maxWidth: '90%',
              maxHeight: '90%',
              borderRadius: '10px',
              boxShadow: '0 0 20px rgba(0,0,0,0.5)',
            }}
            onClick={(e) => e.stopPropagation()}
          />
        </div>
      )}
    </div>
    </>
 {/* Like and Share */}

            
    <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginTop: 15 }}>
  {/* Reply Button */}
  <button
    onClick={() => toggleReplyForm(post.id)}
    style={{
      cursor: 'pointer',
      background: 'transparent',
      border: 'none',
      padding: 0,
      margin: 0,
      display: 'flex',
      alignItems: 'center',
      gap: '6px',
    }}
  >
 
    {/* ✅ Label changes dynamically */}
 
  </button>

  {/* Like Button */}
  <button
    onClick={() => handleLike(post.id, post.group_id)}
    style={{
      background: 'transparent',
      color: userLiked[`post_${post.id}`] ? '#0284c7' : '#374151',
      border: 'none',
      fontWeight: '500',
      display: 'flex',
      alignItems: 'center',
      gap: '6px',
      cursor: 'pointer',
      padding: '4px 8px',
    }}
  >
    {userLiked[`post_${post.id}`] ? <LikeButtons /> : <UnLikeButtons />}
    {likes[`post_${post.id}`] || 0}
  </button>
</div>

{/* Reply Form */}

{/* View/Hide Replies */}
{post.replies && post.replies.length > 0 && (
  <div style={{ marginTop: 10 }}>
    <button
      onClick={() => toggleReplies(post.id)}
      style={{
        background: 'none',
        border: 'none',
        color: '#007bff',
        cursor: 'pointer',
        padding: 0,
        fontSize: 14,
      }}
    >
      {showReplies[post.id]
        ? 'Hide Replies'
        : `View Replies (${post.replies.length})`}
    </button>
  </div>
)}


{/* Replies List */}
{showReplies[post.id] && (
  <div className="group-reply-list">
    {(post.replies || []).map((reply) => (
      <GroupReplyItem
        key={reply.id}
        reply={reply}
        post={post}
        depth={0}
        ctx={replyCtx}
      />
    ))}
  </div>
)}

      </div>
         
          </div>       </div>
        ))
      )}
    </div>
  );

};

export default GroupPosts;
